import React, { useEffect, useState } from "react";
import { Box, Typography, Paper } from "@mui/material";
import {
  PieChart, Pie, Cell, Tooltip, BarChart, Bar, XAxis, YAxis,
  ResponsiveContainer, CartesianGrid
} from "recharts";
import axios from '../../utils/axios';
import TopLinksTable from '../components/TopLinksTable';
import config from '../../config';
const COLORS = ["#6366f1", "#06b6d4", "#eab308", "#f43f5e", "#0ea5e9", "#f97316"];

export default function Stats() {
  const [refData] = useState([
    { name: "Google", value: 160 },
    { name: "Facebook", value: 120 },
    { name: "Zalo", value: 80 },
    { name: "Khác", value: 40 }
  ]);

  const [totals, setTotals] = useState({ links: 0, clicks: 0, users: 0 });
  const [topLinks, setTopLinks] = useState([]);
  const [countryStats, setCountryStats] = useState([]);
  const [browserStats, setBrowserStats] = useState([]);

  useEffect(() => {
    axios.get('/statistics/admin').then(res => {
      setTotals({
        links: res.data.totalLinks,
        clicks: res.data.totalClicks,
        users: res.data.totalUsers
      });

      if (res.data.topLinks) {
        // Giữ nguyên toàn bộ info cho Table, không chỉ mapping mỗi short_code/clicks
        setTopLinks(res.data.topLinks);
      }
    });

    axios.get('/statistics/country').then(res => {
      const mapped = res.data.map(item => ({
        country: item.country || "Unknown",
        count: item.count
      }));
      setCountryStats(mapped);
    });

    axios.get('/statistics/browser').then(res => {
      const mapped = res.data.map(item => ({
        browser: item.browser || "Unknown",
        count: item.count
      }));
      setBrowserStats(mapped);
    });
  }, []);

  return (
    <Box>
      {/* Tổng số liệu */}
      <Box sx={{ display: 'flex', gap: 3, mb: 3, justifyContent: 'center' }}>
        <Paper sx={{ p: 2, minWidth: 120, textAlign: 'center', boxShadow: 2 }}>
          <Typography color="#2563eb" fontWeight={800} fontSize={28}>{totals.links.toLocaleString('vi-VN')}</Typography>
          <Typography fontSize={14}>Links</Typography>
        </Paper>
        <Paper sx={{ p: 2, minWidth: 120, textAlign: 'center', boxShadow: 2 }}>
          <Typography color="#10b981" fontWeight={800} fontSize={28}>{totals.clicks.toLocaleString('vi-VN')}</Typography>
          <Typography fontSize={14}>Clicks</Typography>
        </Paper>
        <Paper sx={{ p: 2, minWidth: 120, textAlign: 'center', boxShadow: 2 }}>
          <Typography color="#f59e0b" fontWeight={800} fontSize={28}>{totals.users.toLocaleString('vi-VN')}</Typography>
          <Typography fontSize={14}>Users</Typography>
        </Paper>
      </Box>

      <Typography variant="h5" fontWeight={800} sx={{ mb: 3 }}>
        Thống kê nâng cao
      </Typography>

      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
        {/* Referrer (Demo tạm) */}
        <Paper sx={{ p: 3, flex: 1, minWidth: 320 }}>
          <Typography fontWeight={700} fontSize={17} sx={{ mb: 2 }}>
            Tỉ lệ referrer (nguồn truy cập)
          </Typography>
          <ResponsiveContainer width="100%" height={220}>
            <PieChart>
              <Pie data={refData} dataKey="value" cx="50%" cy="50%" outerRadius={70} label>
                {refData.map((entry, i) => (
                  <Cell key={`cell-ref-${i}`} fill={COLORS[i % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </Paper>

        {/* Top links */}
        <Paper sx={{ p: 3, flex: 1, minWidth: 320 }}>
          <Typography fontWeight={700} fontSize={17} sx={{ mb: 2 }}>
            Top 5 link nhiều click nhất
          </Typography>
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={topLinks} margin={{ top: 18, right: 10, left: 10, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="short_code" fontSize={15} />
              <YAxis fontSize={15} />
              <Tooltip />
              <Bar dataKey="click_count" fill="#6366f1" />
            </BarChart>
          </ResponsiveContainer>
        </Paper>

        {/* Quốc gia */}
        <Paper sx={{ p: 3, flex: 1, minWidth: 320 }}>
          <Typography fontWeight={700} fontSize={17} sx={{ mb: 2 }}>
            🌍 Quốc gia truy cập
          </Typography>
          <ResponsiveContainer width="100%" height={220}>
            <PieChart>
              <Pie data={countryStats} dataKey="count" nameKey="country" outerRadius={70} label>
                {countryStats.map((entry, i) => (
                  <Cell key={`cell-country-${i}`} fill={COLORS[i % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </Paper>

        {/* Trình duyệt */}
        <Paper sx={{ p: 3, flex: 1, minWidth: 320 }}>
          <Typography fontWeight={700} fontSize={17} sx={{ mb: 2 }}>
            🌐 Trình duyệt phổ biến
          </Typography>
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={browserStats}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="browser" fontSize={14} />
              <YAxis fontSize={14} />
              <Tooltip />
              <Bar dataKey="count" fill="#06b6d4" />
            </BarChart>
          </ResponsiveContainer>
        </Paper>
      </Box>

      {/* BẢNG DỮ LIỆU CHI TIẾT */}
      <TopLinksTable data={topLinks} baseUrl={config.BASE_URL} />
    </Box>
  );
}
